export const latencyNodes = [
  {
    id: "2620:0:862:ed1a::1",
    type: "custom",
    position: { x: 90, y: 230 },
    className: "notebook",
    data: { label: "154.123.1.68" },
    dragHandle: "noDrag",
  },
  {
    id: "195.113.89.35",
    type: "input",
    dragHandle: "noDrag",
    position: { x: 625, y: 450 },
    className: "server-plain non-draggable",
    data: { label: "195.113.89.35" },
  },
  {
    id: "147.32.3.202",
    type: "default",
    position: { x: 240, y: 150 },
    className: "gateway",
    data: { label: "147.32.3.202" },
    dragHandle: "noDrag",
  },
  {
    id: "126.134.35.41",
    type: "default",
    position: { x: 440, y: 130 },
    className: "gateway",
    data: { label: "126.134.35.41" },
    dragHandle: "noDrag",
  },
  {
    id: "71dd::ad48:7474:3412",
    type: "default",
    position: { x: 570, y: 200 },
    className: "gateway",
    data: { label: "71dd::ad48:7474:3412" },
    dragHandle: "noDrag",
  },
  {
    id: "224.109.172.5",
    type: "default",
    position: { x: 440, y: 300 },
    className: "gateway",
    data: { label: "224.109.172.5" },
    dragHandle: "noDrag",
  },
  {
    id: "81.119.95.47",
    type: "default",
    position: { x: 300, y: 400 },
    className: "gateway",
    data: { label: "81.119.95.47" },
    dragHandle: "noDrag",
  },
  {
    id: "2bb6::ae76:435a::1246",
    type: "default",
    position: { x: 440, y: 500 },
    className: "gateway",
    data: { label: "2bb6::ae76:435a::1246" },
    dragHandle: "noDrag",
  },
];
